package com.exura.features.plandefinition.data.repository

import com.exura.features.firebase.data.repository.BaseFirestoreRepository
import com.exura.features.plandefinition.data.mappers.plandefinition.BaseSeriesMappers
import com.exura.features.plandefinition.data.remote.dto.series.BaseSeriesDto
import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import com.exura.features.plandefinition.domain.model.series.BaseSeries
import com.exura.features.plandefinition.domain.repository.PlanSeriesRepository
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.FirebaseFirestore
import kotlinx.serialization.modules.SerializersModule

class PlanSeriesRepositoryImpl(
    firestore: FirebaseFirestore,
    dtoSerializersModule: SerializersModule,
    mapper: BaseSeriesMappers<BaseSeries<out BasePlanElement>, BaseSeriesDto>,
) : PlanSeriesRepository, BaseFirestoreRepository<BaseSeries<out BasePlanElement>, BaseSeriesDto>(
    firestore = firestore,
    dtoSerializersModule = dtoSerializersModule,
    mapper = mapper
) {
    override suspend fun getDto(doc: DocumentSnapshot): BaseSeriesDto = doc.data { serializersModule = dtoSerializersModule }

    override suspend fun setDto(dto: BaseSeriesDto, dest: DocumentReference): DocumentReference {
        dest.set(dto) { serializersModule = dtoSerializersModule }
        return dest
    }

    override suspend fun addDto(dto: BaseSeriesDto, dest: CollectionReference): DocumentReference =
        dest.add(dto) { serializersModule = dtoSerializersModule }
}
